const _Hub_Name = "leadhub";

const _Invoke_Methods_Names = {
  saveGridSettings: "AddLeadGridSetting",
  addLead: "CreateLead",
  updateLead: "UpdateLead",
  deleteLead: "DeleteLead",
  exportLead: "ExportLead",
  addLeadStatus: "CreateLeadStatus",
  editLeadStatus: "UpdateLeadStatus",
  reorderLeadStatus: "SetLeadStatusesOrder",
  deleteLeadStatus: "DeleteLeadStatus",
  markNotificationAsRead: "MarkNotificationAsRead",
  importLead: "ImportLead",
  assignLead: "AssignLead",
  changeLeadStatus: "ChangeLeadStatus",
  changeLeadStatuses: "ChangeLeadStatuses",
  changeLeadValues: "ChangeLeadValues",
  changeLeadAssignees: "ChangeLeadAssignees",

  //Mark lead as seen
  markLeadAsSeen: "MarkLeadAsSeen",

  // User Invite
  addUser: "createUsers",
  updateUser: "updateUser",
  deleteUser: "deleteUser",
  resendInvite: "resendUserInvitation",

  createLeadImport: "CreateLeadImport",
  saveLeadImportEmails: "SaveLeadImportEmails",
  leadImportDuplicates: "GetLeadImportDuplicateRecords",
  saveDuplicateLeads: "SaveDuplicateLeadOptions",
  addLeadSource: "CreateLeadSource",
  editLeadSource: "UpdateLeadSource",
  reorderLeadSource: "SetLeadSourceOrder",
  deleteLeadSource: "DeleteLeadSource",
  createLeadNote: "CreateLeadNote",
  updateLeadNote: "UpdateLeadNote",
  deleteLeadNote: "DeleteLeadNote",

  addTag: "CreateTag",
  editTag: "UpdateTag",
  deleteTag: "DeleteTag",
  reorderTag: "UpdateTagOrder",
  updateAttachment: "UpdateLeadAttachment",
  deleteAttachment: "DeleteLeadAttachment",
  // user profile
  updateUserProfile: "UpdateUserProfile",
  changeUserPassword: "ChangeUserPassword",

  // SMS Template
  createTemplate: "CreateTemplate", //{"Template":{"id":0,"name":"Name of Template",”body”:”body of the template”,"type":1,"requestId":"guid"}}
  updateTemplate: "UpdateTemplate",
  deleteTemplate: "DeleteTemplate",
  previewTemplate: "PreviewTemplate",
  duplicateTemplate: "DuplicateTemplate",

  // API Keys
  createAPIKey: "GenerateNewKey", //{"Template":{"id":0,"name":"Name of Template",”body”:”body of the template”,"type":1,"requestId":"guid"}}
  updateAPIKey: "UpdateAPIKey",
  deleteAPIKey: "RevokeAPIKey",

  // Email Template
  createEmailTemplate: "CreateEmailTemplate",
  updateEmailTemplate: "UpdateEmailTemplate",
  deleteEmailTemplate: "DeleteEmailTemplate",
  previewEmailTemplate: "PreviewEmailTemplate",
  duplicateEmailTemplate: "DuplicateEmailTemplate",

  // Email Signature
  createEmailSignature: "CreateEmailSignature",
  updateEmailSignature: "UpdateEmailSignature",
  updateDefaultEmailSignature: "UpdateDefaultEmailSignature",
  deleteEmailSignature: "DeleteEmailSignature",
  duplicateEmailSignature: "DuplicateEmailSignature",

  // list
  createList: "CreateList",
  updateList: "UpdateList",
  deleteList: "DeleteList",
  duplicateList: "DuplicateList",

  //  list leads with expression
  saveListLeads: "SaveListLeads",
  updateList: "UpdateList",
  deleteList: "DeleteList",
  duplicateList: "DuplicateList",

  // customFields
  createCustomField: "CreateCustomField",
  updateCustomField: "UpdateCustomField",
  deleteCustomField: "DeleteCustomField",
  reorderCustomField: "SetCustomFieldOrder",

  // lead scoring
  createLeadScoringRule: "CreateLeadScoringRule",
  updateLeadScoringRule: "UpdateLeadScoringRule",
  deleteLeadScoringRule: "DeleteLeadScoringRule",

  // email integration
  connectEmail: "ConnectUserEmail",
  reConnectEmail: "ReconnectUserEmail",
  updateDefaultEmailAccount: "UpdateDefaultEmailAccount",
  updateEmailAccountStatus: "UpdateEmailAccountStatus",
  updateEmailTracking: "UpdateEmailTracking",
  deleteEmailAccount: "DeleteEmailAccount",

  // advance email setting integration
  // domain
  createDomain: "CreateDomain",
  verifyDomain: "VerifyDomain",
  deleteDomain: "DeleteDomain",
  // create email
  createSenderSignature: "CreateSenderSignature",
  updateSenderSignature: "UpdateSenderSignature",
  deleteSenderSignature: "DeleteSenderSignature",
  // reply-to email
  createReplyToEmail: "CreateReplyToEmail",
  updateReplyToEmail: "UpdateReplyToEmail",
  deleteReplyToEmail: "DeleteReplyToEmail",
  updateDefaultReplyToEmail: "UpdateDefaultReplyToEmail",

  // appointment
  connectCalendar: "ConnectCalendar",
  deleteMember: "DeleteMember",

  //communication permissions
  smsConsentSetting: "SaveSMSConsentSetting",

  // delete email template asset
  deleteMediaAsset: "DeleteMediaAsset",

  // user settings
  createUserSettings: "CreateUserSetting",

  // mark notifications as read
  markAllAsRead: "MarkNotificationAsSeen",

  // room
  joinRoom: "JoinRoom",
  leftRoom: "LeftRoom",
};

const _OnReceive_Methods_Names = {
  onSaveGridSettings: "CreateLeadGridSettingResponse",
  onAddLead: "CreateLeadResponse",
  onUpdateLead: "UpdateLeadResponse",
  onDeleteLead: "DeleteLeadResponse",
  onExportLead: "ExportLeadResponse",
  onAddLeadStatus: "CreateLeadStatusResponse",
  onEditLeadStatus: "UpdateLeadStatusResponse",
  onReorderLeadStatus: "UpdateLeadStatusOrderResponse",
  onDeleteLeadStatus: "DeleteLeadStatusResponse",
  onNotificationArrived: "NotificationSavedResponse",
  onUpdateNotificationResponse: "UpdateNotificationResponse",
  onActivityLogResponse: "ActivityLogged",
  onAddUser: "CreateUserResponse",
  onUpdateUser: "UpdateUserResponse",
  onDeleteUser: "DeleteUserResponse",
  onImportLead: "ImportLeadResponse",
  onLeadImportDuplicate: "GetLeadImportDuplicateResponse",
  onCreateLeadImportResponse: "CreateLeadImportResponse",
  onSaveDuplicateLeads: "SaveLeadImportDuplicateResponse",
  onAddLeadSource: "CreateLeadSourceResponse",
  onEditLeadSource: "UpdateLeadSourceResponse",
  onReorderLeadSource: "UpdateLeadSourceOrderResponse",
  onDeleteLeadSource: "DeleteLeadSourceResponse",
  onCreateNote: "CreateLeadNoteResponse",
  onEditNote: "UpdateLeadNoteResponse",
  onDeleteNote: "DeleteLeadNoteResponse",
  onAddTagResponse: "CreateTagResponse",
  onEditTagResponse: "UpdateTagResponse",
  onDeleteTagResponse: "DeleteTagResponse",
  onReorderTag: "UpdateTagOrderResponse",
  onUpdateAttachment: "UpdateLeadAttachmentResponse",
  onDeleteAttachment: "DeleteLeadAttachmentResponse",
  changeLeadStatusesResponse: "ChangeLeadStatusesResponse",
  changeLeadValuesResponse: "ChangeLeadValuesResponse",
  changeLeadAssigneesResponse: "ChangeLeadAssigneesResponse",

  // mark lead as seen listener
  onMarkLeadAsSeen: "MarkLeadAsSeenResponse",

  // user profile
  onUpdateProfile: "UpdateProfileResponse",
  onUserPasswordChange: "UserPasswordChangeResponse",

  // SMS Template
  onCreateTemplate: "CreateTemplateResponse", //{"Template":{"id":0,"name":"Name of Template",”body”:”body of the template”,"type":1,"requestId":"guid"}}
  onUpdateTemplate: "UpdateTemplateResponse",
  onDeleteTemplate: "DeleteTemplateResponse",
  onPreviewTemplate: "PreviewTemplateResponse",
  onDuplicateTemplate: "DuplicateTemplateResponse",

  // APIKeys
  onCreateAPIKey: "CreateAPIKeyResponse", //{"Template":{"id":0,"name":"Name of Template",”body”:”body of the template”,"type":1,"requestId":"guid"}}
  onUpdateAPIKey: "UpdateAPIKeyResponse",
  onDeleteAPIKey: "RevokeAPIKeyResponse",

  // Email Template
  onCreateEmailTemplate: "CreateEmailTemplateResponse", //{"Template":{"id":0,"name":"Name of Template",”body”:”body of the template”,"type":1,"requestId":"guid"}}
  onUpdateEmailTemplate: "UpdateEmailTemplateResponse",
  onDeleteEmailTemplate: "DeleteEmailTemplateResponse",
  onPreviewEmailTemplate: "PreviewEmailTemplateResponse",
  onDuplicateEmailTemplate: "DuplicateEmailTemplateResponse",

  // Email Signature
  onCreateEmailSignature: "CreateEmailSignatureResponse",
  onUpdateEmailSignature: "UpdateEmailSignatureResponse",
  onUpdateDefaultEmailSignature: "UpdateDefaultEmailSignatureResponse",
  onDeleteEmailSignature: "DeleteEmailSignatureResponse",
  onDuplicateEmailSignature: "DuplicateEmailSignatureResponse",

  // list
  onCreateList: "CreateListResponse",
  onUpdateList: "UpdateListResponse",
  onDeleteList: "DeleteListResponse",
  onDuplicateList: "DuplicateListResponse",

  // customFields
  onCreateCustomField: "CreateCustomFieldResponse",
  onUpdateCustomField: "UpdateCustomFieldResponse",
  onDeleteCustomField: "DeleteCustomFieldResponse",
  onReorderCustomField: "UpdateLeadStatusOrderResponse",

  // list leads
  onSaveListLeads: "SaveListLeadsResponse",

  // lead individual field update
  assignLeadResponse: "AssignLeadResponse",
  changeLeadStatusResponse: "ChangeLeadStatusResponse",
  // lead scoring
  createLeadScoringRuleResponse: "CreateLeadScoringRuleResponse",
  updateLeadScoringRuleResponse: "UpdateLeadScoringRuleResponse",
  deleteLeadScoringRuleResponse: "DeleteLeadScoringRuleResponse",

  // email integration
  onConnectEmail: "ConnectUserEmailResponse",
  onReconnectEmail: "ReconnectUserEmailResponse",
  onUpdateDefaultEmailAccount: "UpdateDefaultEmailAccountResposne",
  onUpdateEmailAccountStatus: "UpdateEmailAccountStatusResponse",
  onUpdateEmailTracking: "UpdateEmailTrackingResponse",
  onDeleteEmailAccount: "DeleteEmailAccountResponse",

  // advance email setting integration
  // domain
  onCreateDomain: "CreateDomainResponse",
  onVerifyDomain: "VerifyDomainResponse",
  onDeleteDomain: "DeleteDomainResponse",
  // create email
  onCreateSenderSignature: "CreateSenderSignatureResponse",
  onUpdateSenderSignature: "UpdateSenderSignatureResponse",
  onDeleteSenderSignature: "DeleteSenderSignatureResponse",
  // reply-to email
  onCreateReplyToEmail: "CreateReplyToEmailResponse",
  onUpdateReplyToEmail: "UpdateReplyToEmailResponse",
  onDeleteReplyToEmail: "DeleteReplyToEmailResponse",
  onUpdateDefaultReplyToEmail: "UpdateDefaultReplyToEmailResponse",

  // appointment
  onConnectCalendarResponse: "ConnectCalendarResponse",
  onDeleteMemberResponse: "DeleteMemberResposne",

  //communication permissions
  onSmsConsentSettingResponse: "SaveSMSConsentSettingResponse",

  // delete email template asset
  onDeleteMediaAsset: "DeleteMediaAssetResponse",

  // user settings
  onCreateUserSettings: "CreateUserSettingResponse",
};

const Lead_signalr = {
  hubName: _Hub_Name,
  InvokeMethodNames: _Invoke_Methods_Names,
  onReceiveMethodNames: _OnReceive_Methods_Names,
};

export default Lead_signalr;
